// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"37ee2c7c","496":"66a07ee0"}[chunkId] + ".chunk.js";
};